import { Navigate } from "react-router";
import { useSelector } from "react-redux";

/**
 * Requires a consumer session (token). Email/phone OTP verification is only enforced
 * during registration (`/verify-account`); successful password sign-in is treated as full access.
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.infoboxx_consumer);

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute;
